module.exports = __webpack_public_path__ + "/login_ui/img/bf-9009ba270c5cccfa5e40c11b526bcecb.svg";